import { isAnyArray } from 'is-any-array';
import generateID from './generateID';
import { getData } from './getData';
export function formatSpectrum1D(spectrumData) {
    const { id = generateID(), meta, peaks = {}, filters = [], info = {}, ranges = {}, integrals = {}, selector, dependentVariables = [], ...residualSpectrumData } = spectrumData;
    let spectrum = { id, meta, filters };
    let { data = getData(dependentVariables[0].components) } = spectrumData;
    if (isAnyArray(data.im))
        info.isComplex = true;
    if (Array.isArray(info.nucleus))
        info.nucleus = info.nucleus[0];
    spectrum.data = {
        ...{
            x: [],
            re: [],
            im: [],
        },
        ...data,
    };
    if (selector) {
        spectrum.selector = selector;
    }
    spectrum.info = {
        ...{
            nucleus: '1H',
            isFid: false,
            isComplex: false,
            dimension: 1,
            name: info?.name || id,
        },
        ...info,
    };
    spectrum.display = {
        isVisible: true,
        isPeaksMarkersVisible: true,
        isRealSpectrumVisible: true,
        isVisibleInDomain: true,
        ...spectrumData.display,
    };
    spectrum.peaks = { ...{ values: [], options: {} }, ...peaks };
    spectrum.ranges = { ...{ values: [], options: {} }, ...ranges };
    spectrum.integrals = { ...{ values: [], options: {} }, ...integrals };
    spectrum.ranges = {
        ...{ values: [] },
        ...spectrumData.ranges,
    };
    return { ...residualSpectrumData, ...spectrum };
}
//# sourceMappingURL=formatSpectrum1D.js.map